import NetworkService from "../services/network-service";
import {declension, getRandomInt} from "../helpers/utils";
import DateHelper from "../helpers/date-helper";
import {COURSE_CARDS_BADGES_FETCHED_EVENT} from "../constants/events";
import LocalizationsHelper from "../helpers/localizations-helper";

export default class CourseCardsBadges {
    constructor() {
        this.courseEntryIds = craft.page.courseEntryIds;
        this.init();
    }

    init() {
        NetworkService
            .post(`${NetworkService.restSiteUrl}/1.0/courses/statistics/bulk`, { entryIds: this.courseEntryIds })
            .then(({ data }) => {
                const { success, status, response } = data;

                if (success && status === 'ok' && response) {
                    return response || [];
                }

                return [];
            })
            .then(dataList => {
                const badgesMap = new Map();
                dataList.forEach(dataItem => {
                    badgesMap.set(`${dataItem.id}`, this.toBadge(dataItem));
                });

                window.badgesMap = badgesMap;
                window.dispatchEvent(new CustomEvent(COURSE_CARDS_BADGES_FETCHED_EVENT, { detail: badgesMap }));
            });
    }

    toBadge(data) {
        const defaultBadge = {
            label: LocalizationsHelper.get('page.course.freeLesson.title'),
            color: 'violet'
        };

        if (!data) {
            return defaultBadge;
        }

        if (data.days_start && data.days_start <= 3 && data.start_date) {
            const startDate = new Date(data.start_date);
            return {
                label: `${craft.localization['teens.components.courseBadge.beginAlready']} ${startDate.getDate()} ${DateHelper.getWhenStartMonth(startDate.getMonth())}`,
                color: 'yellow'
            }
        }

        if (data.last_week && data.last_week >= 5) {
            return {
                label: `${data.last_week === 1 ?
                    craft.localization.peoplePerWeek[0] :
                    craft.localization.peoplePerWeek[1]} ${data.last_week} ${declension(data.last_week, craft.localization.people)}`,
                color: 'green'
            }
        }

        if (data.places && data.places <= 3) {
            return {
                label: `${data.places} ${declension(data.places, craft.localization.places)}`,
                color: 'green'
            }
        }

        return defaultBadge;
    }
}